<template>
  <a-modal
      :title="$t('personSetting.GeneralSettings')"
      :width="720"
      :height="446"
      :maskStyle="{backgroundColor: 'rgba(10, 15, 26, 0.1)'}"
      destroy-on-close
      :visible="visible"
      :footer="null"
      @change="$emit('change', $event)"
  >
    <div class="form">
      <a-form layout="horizontal">
        <a-form-item :label="$t('personSetting.Definition')">
          <a-radio-group v-model="selectedResolution" class="resolution-radio">
            <a-radio
              v-for="item in candidates"
              :value="item.value"
              :key="item.value"
            >
              {{item.label}}
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item :label="$t('personSetting.JoinCollaborativeMute')">
          <div class="switch" v-if="+muteType === 1" @click="_ => muteType = 0">
            <svg-icon icon-class="switch-on" class-name="switch-on" />
            <span class="text">{{$t('common.TurnOn')}}</span>
          </div>
          <div class="switch" v-if="+muteType === 0" @click="_ => muteType = 1">
            <svg-icon icon-class="switch-off" class-name="switch-off"/>
            <span class="text">{{$t('common.Close')}}</span>
          </div>
        </a-form-item>
        <a-form-item :label="$t('common.Language')">
          <a-radio-group v-model="language" class="language-radio">
            <a-radio :value="LANGUAGE.CHINESE">{{$t('common.Chinese')}}</a-radio>
            <a-radio :value="LANGUAGE.ENGLISH">{{$t('common.English')}}</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item  :label="$t('personSetting.ApplyLabelAuth')" class="mark-info-parent">
          <div class="switch" v-if="labelAuthApply" @click="_ => labelAuthApply = false">
            <svg-icon icon-class="switch-on" class-name="switch-on" />
            <span class="text">{{$t('common.TurnOn')}}</span>
          </div>
          <div class="switch" v-if="!labelAuthApply" @click="_ => labelAuthApply = true">
            <svg-icon icon-class="switch-off" class-name="switch-off"/>
            <span class="text">{{$t('common.Close')}}</span>
          </div>
        </a-form-item>
        <div class="mark-info" v-if="showMarkInfo">
          <span>{{$t('personSetting.ApplyLabelAuthInfo')}}</span>
          <a-icon type="close-circle" @click="showMarkInfo = false" />
        </div>
      </a-form>
    </div>
    <BasicBtnGroup :primary-content="$t('common.Ok')" @primeClick="onOk" @defClick="onCancel"/>
  </a-modal>
</template>

<script>
import { db } from '@/utils/db'
import { map } from 'ramda'
import BasicBtnGroup from '@/components/behavior/basic-btn-group/index.vue'
import { LANGUAGE } from '@/utils/constant'

export default {
  name: 'ResolutionModal',
  components: { BasicBtnGroup },
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      LANGUAGE: LANGUAGE,
      candidates: map(v => ({ value: v, label: v, key: v }), ['360p', '720p', '1080p']),
      selectedResolution: '720p',
      muteType: 0,
      language: '',
      labelAuthApply: true,
      showMarkInfo: true
    }
  },
  created() {
    this.showMarkInfo = true
    this.initData()
  },
  methods: {
    async initData(){
      this.selectedResolution = await this.$store.dispatch('getResolutionSetting')
      this.muteType = await this.$store.dispatch('getMetuTypeSetting')
      const language = await this.$store.dispatch('getLanguageSetting')
      if (language !== this.$i18n.locale) {
        this.language = this.$i18n.locale
      } else {
        this.language = language
      }
      this.labelAuthApply = await this.$store.dispatch('getLabelAuthAppltSetting')
    },
    async onOk(){
      const d = {
        uid: this.$store.state.userInfo.id,
        resolution: this.selectedResolution,
        muteType: this.muteType,
        language: this.language,
        labelAuthApply: this.labelAuthApply
      }
      await db.userPreferences.put(d)
      this.$store.commit('setLanguage', this.language)
      this.$nextTick(_ => {
        this.$message.success(this.$t('home.SetSuccessfully'))
      })
      this.onCancel()
    },
    onCancel(){
      this.$emit('change', false)
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .ant-modal-content {
  border-radius: 16px;
  .ant-modal-header {
    padding-left: 56px;
    padding-top: 32px;
    .ant-modal-title {
      font-weight: bold;
      font-size: 18px;
    }
    border-radius: 16px 16px 0 0;
  }
  .ant-modal-body {
    height: 400px;
    padding: 39px 56px 69px 56px;
    position: relative;
    .form {
      .ant-form-item{
        display: flex;
      }
      .ant-form-item-label{
        font-weight: bold;
        font-size: 18px;
        width: 180px;
        text-align: left;
        line-height:1.5;
        flex-shrink:0;
        label::after{
          display: none;
        }
      }
      .ant-form-item-control-wrapper{
        flex: 1;
      }
      .resolution-radio {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        &.mute{
          justify-content: start;
        }
        .ant-radio-wrapper {
          width: 110px;
          span:last-child{
            font-size: 16px;
            color: #000;
            font-weight: 500;
          }
        }
      }
      .language-radio {
        width: 100%;
        display: flex;
        flex-direction: row;
        &.mute{
          justify-content: start;
        }
        .ant-radio-wrapper {
          width: 110px;
          span:last-child{
            font-size: 16px;
            color: #000;
            font-weight: 500;
          }
        }
      }
      .switch{
        display: flex;
        align-items: center;
        .text{
          margin-left: 10px;
          line-height: 27px;
        }
      }
      .mark-info-parent{
        margin-bottom: 16px;
      }
      .mark-info{
        // position: absolute;
        // top: 43px;
        // left: -180px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 13px;
        line-height: 18px;
        background: #F1F6FB;
        border-radius: 4px;
        padding:9px 15px;
        color: #7C7D81;
        margin-bottom: 24px;
        .anticon-close-circle{
          cursor: pointer;
        }
      }
    }

    .basic-btn-group {
      width: 100%;
      justify-content: flex-end;
      position: absolute;
      right: 56px;
      bottom: 48px;

      > button {
        margin-right: 40px;
        &:first-child {
          color: #000;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}

</style>
